@if (fieldData().readonly) {
    <cipo-text-view [config]="fieldData()" [value]="control().value" [attr.data-testid]="fieldData().testId" />
} @else {
    <div class="cipo--width--full" [attr.data-testid]="fieldData().testId">
        @if (!fieldData()?.multiple) {
            <mat-form-field
                class="cipo--width--full"
                [appearance]="fieldData().appearanceFill ? 'fill' : 'outline'"
                [ngClass]="{
                    'cipo-mark-changed': fieldData().markChanged && valueChanged(),
                }">
                @if (fieldData().label) {
                    <mat-label>{{ fieldData().label | translate }}</mat-label>
                }

                @if (fieldData().multiline) {
                    <textarea
                        matInput
                        #textInput
                        data-testid="cipo-text-input"
                        [formControl]="control()"
                        [maxlength]="fieldData().maxLength ?? null"
                        [placeholder]="fieldData().placeholder ?? '' | translate"
                        [attr.autocomplete]="fieldData().autocomplete ?? null"
                        [cdkTextareaAutosize]="true"
                        [cdkAutosizeMaxRows]="autosizeMaxRows()"></textarea>
                } @else {
                    <input
                        matInput
                        #textInput
                        data-testid="cipo-text-input"
                        [formControl]="control()"
                        [maxlength]="fieldData().maxLength ?? null"
                        [attr.autocomplete]="fieldData().autocomplete ?? null"
                        [placeholder]="fieldData().placeholder ?? '' | translate" />
                }

                @if (fieldData().prefixIcon) {
                    <mat-icon matPrefix>{{ fieldData().prefixIcon }}</mat-icon>
                }
                @if (fieldData().prefix) {
                    <span matTextPrefix>{{ fieldData().prefix | translate }}</span>
                }

                @if (fieldData().suffixIcon) {
                    <mat-icon matSuffix>{{ fieldData().suffixIcon }}</mat-icon>
                }
                @if (fieldData().suffix) {
                    <span matTextSuffix>{{ fieldData().suffix | translate }}</span>
                }
                @if (canClearInput() && control().value && !control().disabled) {
                    <button
                        matSuffix
                        mat-icon-button
                        data-testid="cipo-text-input-clear"
                        [attr.aria-label]="'a11y.form.clearInput' | translate"
                        (click)="clearValue()">
                        <mat-icon aria-hidden="true">close</mat-icon>
                    </button>
                } @else if (fieldData().fieldDescription) {
                    <mat-icon
                        matSuffix
                        data-testid="cipo-text-input-info"
                        class="material-icons-outlined cipo--cursor--help"
                        [title]="fieldData().fieldDescription | translate">
                        info
                    </mat-icon>
                }
                <mat-error>
                    {{
                        control().hasError("custom")
                            ? control().errors.custom
                            : control().hasError("email")
                              ? ("errors.email" | translate)
                              : ("errors.required" | translate)
                    }}
                </mat-error>
                @if (fieldData().hint) {
                    <mat-hint>{{ fieldData().hint | translate }}</mat-hint>
                }
            </mat-form-field>
        } @else {
            <mat-form-field
                class="cipo--width--full"
                [appearance]="fieldData().appearanceFill ? 'fill' : 'outline'"
                [ngClass]="{
                    'cipo-mark-changed': fieldData().markChanged && valueChanged(),
                }">
                @if (fieldData().label) {
                    <mat-label>{{ fieldData().label | translate }}</mat-label>
                }
                <mat-chip-grid
                    #chipGrid
                    [formControl]="control()"
                    class="cipo--overflow-y--auto"
                    [style.maxHeight]="maxHeight()">
                    @for (value of control().value; track $index) {
                        <mat-chip-row
                            data-testid="cipo-text-input-chip"
                            (removed)="remove($index)"
                            [editable]="false"
                            (click)="edit($index)">
                            {{ value | translate }}
                            <button
                                matChipRemove
                                data-testid="cipo-text-input-chip-remove"
                                [attr.aria-label]="'a11y.form.removeChip' | translate: { value: value }">
                                <mat-icon aria-hidden="true">cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                    <input
                        #chipInput
                        data-testid="cipo-text-input"
                        [matChipInputFor]="chipGrid"
                        [matChipInputAddOnBlur]="true"
                        (matChipInputTokenEnd)="add($event)" />
                </mat-chip-grid>
                <mat-error>
                    {{
                        control().hasError("custom")
                            ? control().errors.custom
                            : control().hasError("email")
                              ? ("errors.email" | translate)
                              : ("errors.required" | translate)
                    }}
                </mat-error>
                @if (fieldData().hint) {
                    <mat-hint>{{ fieldData().hint | translate }}</mat-hint>
                }
            </mat-form-field>
        }
    </div>
}
